<template>
  <div id="polyData" style="width: 100%;height: 100%;background-color: transparent">
  </div>
</template>

<script>
import '@kitware/vtk.js/Rendering/Profiles/Geometry';

import vtkRenderWindowWithControlBar from '@kitware/vtk.js/Rendering/Misc/RenderWindowWithControlBar';
import util from "@/util/util";
import vtkUtil from "@/util/vtkUtil";
import vtkDataArray from "@kitware/vtk.js/Common/Core/DataArray";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import vtkPolyDataReader from '@kitware/vtk.js/IO/Legacy/PolyDataReader';
import vtkOBJReader from "@kitware/vtk.js/IO/Misc/OBJReader";
import vtkCellPicker from "@kitware/vtk.js/Rendering/Core/CellPicker";
import vtkSphereSource from "@kitware/vtk.js/Filters/Sources/SphereSource";
// import vtkTubeFilter from "@kitware/vtk.js/Filters/General/TubeFilter";

export default {
  name: "ziBrain",
  props:{
    rotation : Boolean
  },
  data() {
    return {
      renderWindow:{},
      renderer : {},
      lineActor : {},
      brainActorList : [],
      showBrainFlag : true,
      showLineFlag : true,
      pointList: [],
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
      fullScreenRenderer.setContainer(document.getElementById("polyData"))
      // fullScreenRenderer.setBackground([0.19607,0.0549,0.2549])
      fullScreenRenderer.setBackground([0.15,0.15,0.15])
      // fullScreenRenderer.setBackground([1,1,1])
      fullScreenRenderer.setControlSize(0);
      this.renderer = fullScreenRenderer.getRenderer();
      // this.renderer.setBackground(1,1,1,0)
      this.renderWindow = fullScreenRenderer.getRenderWindow();
      // this.readVtkFile(util.baseUrl + "whole_5000_low.vtk", this.renderer, this.renderWindow);
      this.readObjMode(util.baseUrl + "BrainMesh_Ch2.obj", this.renderer, this.renderWindow);

      this.readVtkFile(util.baseUrl + "whole_5000_adjust_color_zi_0_7_ds_0_5_4.vtk", this.renderer, this.renderWindow);
      // vtkUtil.readVtkFile(util.baseUrl + "my.vtk", renderer, renderWindow);
      // vtkUtil.readVtkFile(util.baseUrl + "RGB_3_lines.vtk", this.renderer, this.renderWindow);
    },
    readObjMode(url, renderer, renderWindow){
      const reader = vtkOBJReader.newInstance();
      const picker = vtkCellPicker.newInstance();
      this.brainActorList = [];
      picker.setPickFromList(1);
      picker.setTolerance(0);
      picker.initializePickList();
      reader.setUrl(url).then(() => {
        const size = reader.getNumberOfOutputPorts();
        for (let i = 0; i < size; i++) {
          const polydata = reader.getOutputData(i);
          const mapper = vtkMapper.newInstance();
          const actor = vtkActor.newInstance();
          actor.setMapper(mapper);
          actor.getProperty().setOpacity(0.2)
          mapper.setInputData(polydata);
          renderer.addActor(actor);
          picker.addPickList(actor);
          this.brainActorList.push(actor)
        }
        renderWindow.getInteractor().onRightButtonPress((callData) => {
          if (renderer !== callData.pokedRenderer) {
            return;
          }
          const pos = callData.position;
          const point = [pos.x, pos.y, 0.0];
          picker.pick(point, renderer);
          if (picker.getActors().length > 0) {
            const pickedPoint = picker.getPickPosition();
            const sphere = vtkSphereSource.newInstance();
            this.pointList.push(pickedPoint);
            console.log(this.pointList);
            sphere.setCenter(pickedPoint);
            sphere.setRadius(1);
            const sphereMapper = vtkMapper.newInstance();
            sphereMapper.setInputData(sphere.getOutputData());
            const sphereActor = vtkActor.newInstance();
            sphereActor.setMapper(sphereMapper);
            sphereActor.getProperty().setColor(1.0, 0.0, 0.0);
            renderer.addActor(sphereActor);
            renderWindow.render();
          }
        });
        renderer.resetCamera();
        renderWindow.render();
      });
    },
    readVtkFile(url, renderer, renderWindow){
      const reader = vtkPolyDataReader.newInstance();
      reader.setUrl(url).then(() => {
        const polydata = reader.getOutputData(0);
        let list = reader.toJSON().parseData.split("LOOKUP_TABLE default");
        let listElement = list[list.length -1];
        let split = listElement.trim().split(/\s+/);
        // let max = Math.max(...split);
        // let min = Math.min(...split);
        let max = 1;
        let min = 0;
        var values = new Float32Array(split);
        const colors = vtkDataArray.newInstance({name: 'points', values});
        polydata.getPointData().setScalars(colors);
        const mapper = vtkMapper.newInstance({});
        // var colorTransferFunction = vtkUtil.getColorTransferFunction();
        var colorTransferFunction = vtkUtil.getColorTransferFunctionByColorUtil();
        // var tubeFilter = vtkTubeFilter.newInstance();
        // tubeFilter.setInputData(polydata)
        // tubeFilter.setRadius(0.1);
        // tubeFilter.setNumberOfSides(5);
        // tubeFilter.setCapping(true);
        // mapper.setScalarModeToUsePointFieldData()
        // mapper.setColorByArrayName("points")
        mapper.setLookupTable(colorTransferFunction);
        mapper.setScalarRange([min, max])
        mapper.setInputData(polydata)
        // mapper.setInputConnection(tubeFilter.getOutputPort());
        const actor = vtkActor.newInstance();
        actor.setMapper(mapper);
        console.log(actor.getActors())
        console.log(actor.getProperty())
        renderer.addActor(actor);
        renderer.resetCamera();
        renderWindow.render();
        this.lineActor = actor;
        if (this.rotation){
          window.requestAnimationFrame(this.animate);
        }
      });
    },
    updateCamera(renderer) {
      const camera = renderer.getActiveCamera();
      camera.azimuth(0.1);
      renderer.resetCameraClippingRange();
    },
    animate() {
      Object.values([this.renderer]).forEach(this.updateCamera);
      this.renderWindow.render();
      window.requestAnimationFrame(this.animate);
    },
    showModal(){
      this.renderer.removeAllActors();
      if (this.showBrainFlag){
        this.renderer.addActor(this.brainActorList);
      }
      if (this.showLineFlag){
        this.renderer.addActor(this.lineActor);
      }
      this.renderer.resetCamera();
      this.renderWindow.render();
    }
  },
  watch:{
    showBrainFlag(){
      this.showModal();
    },
    showLineFlag(){
      this.showModal();
    }
  }
}
</script>

<style scoped>

</style>